<template>
    <Layout :pagetitle="'品牌列表'">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title mb-0">品牌列表</h4>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>查詢條件
                                    </h5>
                                    <div class="row">
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="name">品牌名稱</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.name"
                                                       id="name" placeholder="輸入品牌名稱">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="companyName">公司名稱</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.companyName"
                                                       id="companyName" placeholder="輸入公司名稱">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="businessId">統一編號</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.businessId"
                                                       id="businessId" placeholder="輸入統一編號">
                                            </div>
                                        </div>
                                        <div class="col-md-3">
                                            <div class="mb-3">
                                                <label class="form-label" for="primaryOperatorSubject">主要操作人</label>
                                                <input class="form-control" type="text"
                                                       v-model="searchCondition.primaryOperatorSubject"
                                                       id="primaryOperatorSubject" placeholder="輸入帳號或 Subject">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-4">
                                        <div class="hstack gap-3">
                                            <button type="submit" @click.prevent="doSearch"
                                                    class="btn btn-primary w-md">
                                                搜尋
                                            </button>
                                            <div class="vr"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="mt-4 mt-xl-0">
                                    <h5 class="font-size-14 mb-4">
                                        <i class="mdi mdi-arrow-right text-primary me-1"></i>列表
                                    </h5>
                                    <div class="row">
                                        <Grid :style="{ height: '100%' }" :data-items="result" :sortable="true"
                                              :pageable="{ refresh: true, pageSizes: [10, 25, 50, 100], buttonCount: 5 }"
                                              :scrollable="'none'"
                                              :filterable="false" :filter="filter" :sort="sort"
                                              @sortchange="sortChangeHandler" @pagechange="pageChangeHandler"
                                              :skip="skip"
                                              :take="take" :total="total" :columns="columns">
                                            <template v-slot:impersonateCell="{ props }">
                                                <td>
                                                    <button class="btn btn-sm btn-outline-secondary me-1"
                                                            :disabled="impersonateLoadingId === props.dataItem.id"
                                                            @click="openImpersonate(props.dataItem.id)">
                                                        {{ impersonateLoadingId === props.dataItem.id ? '處理中...' : '代看' }}
                                                    </button>
                                                    <button class="btn btn-sm btn-outline-primary me-1"
                                                            @click="openLineDialog(props.dataItem)">
                                                        LINE 設定
                                                    </button>
                                                    <button class="btn btn-sm btn-outline-success me-1"
                                                            :disabled="!props.dataItem.hasLineChannel || richMenuUploadingId === props.dataItem.id"
                                                            :title="!props.dataItem.hasLineChannel ? '請先設定 LINE Channel' : ''"
                                                            @click="openRichMenuPicker(props.dataItem.id)">
                                                        {{ richMenuUploadingId === props.dataItem.id ? '上傳中...' : '圖文選單' }}
                                                    </button>
                                                    <button class="btn btn-sm btn-outline-info"
                                                            :disabled="!props.dataItem.hasLogo"
                                                            :title="!props.dataItem.hasLogo ? '此品牌尚未上傳 LOGO' : ''"
                                                            @click="downloadLogo(props.dataItem.id)">
                                                        下載 LOGO
                                                    </button>
                                                </td>
                                            </template>
                                        </Grid>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="showLineDialog" class="line-dialog-backdrop">
            <div class="card line-dialog-card">
                <div class="card-header d-flex justify-content-between align-items-center">
                    <h5 class="card-title mb-0">
                        {{ lineExisting ? '編輯' : '新增' }} LINE Channel — {{ lineForm.brandName }}
                    </h5>
                    <button type="button" class="btn-close" @click="closeLineDialog"></button>
                </div>
                <div class="card-body">
                    <p v-if="lineDialogLoading" class="text-muted font-size-12 mb-3">讀取中...</p>
                    <p v-else class="text-muted font-size-12 mb-3">
                        從 LINE Developers 後台複製以下欄位。儲存後會自動同步 Destination 與加好友連結並驗證 Token。
                    </p>

                    <div v-if="lineExisting" class="alert alert-info py-2 mb-3 font-size-12">
                        <div><strong>目前綁定</strong></div>
                        <div>Destination：{{ lineExisting.destination || '（尚未同步）' }}</div>
                        <div>加好友連結：{{ lineExisting.addFriendUrl || '（尚未同步）' }}</div>
                    </div>

                    <div class="mb-2">
                        <label class="form-label">LINE Provider ID <span class="text-danger">*</span></label>
                        <input class="form-control" v-model="lineForm.providerId" placeholder="LINE Developers 的 Provider ID">
                    </div>
                    <div class="mb-2">
                        <label class="form-label">Provider 名稱（選填）</label>
                        <input class="form-control" v-model="lineForm.providerName">
                    </div>
                    <div class="mb-2">
                        <label class="form-label">Channel ID <span class="text-danger">*</span></label>
                        <input class="form-control" v-model="lineForm.channelId">
                    </div>
                    <div class="mb-2">
                        <label class="form-label">LIFF ID</label>
                        <input class="form-control" v-model="lineForm.liffId">
                    </div>
                    <div class="mb-2">
                        <label class="form-label">
                            Channel Access Token
                            <span v-if="lineExisting" class="text-muted font-size-11">（留空沿用既有）</span>
                        </label>
                        <textarea class="form-control" rows="2" v-model="lineForm.accessToken"
                                  :placeholder="lineExisting ? '留空即不變更既有 Token' : ''"></textarea>
                    </div>
                    <div class="mb-2">
                        <label class="form-label">
                            Channel Secret
                            <span v-if="lineExisting" class="text-muted font-size-11">（留空沿用既有）</span>
                        </label>
                        <input class="form-control" v-model="lineForm.channelSecret"
                               :placeholder="lineExisting ? '留空即不變更既有 Secret' : ''">
                    </div>
                </div>
                <div class="card-footer d-flex justify-content-end gap-2">
                    <button class="btn btn-outline-secondary" :disabled="lineSaving" @click="closeLineDialog">取消</button>
                    <button class="btn btn-primary" :disabled="lineSaving" @click="saveLineChannel">
                        {{ lineSaving ? '儲存中...' : '儲存並同步' }}
                    </button>
                </div>
            </div>
        </div>
        <input type="file" ref="richMenuFileInput" accept="image/png,image/jpeg"
               style="display:none" @change="onRichMenuFileSelected">

        <loading v-model:active="isLoading" :can-cancel="true" :is-full-page="fullPage"/>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import {Grid} from "@progress/kendo-vue-grid";
import {toDataSourceRequestString} from "@progress/kendo-data-query";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
    mounted: function () {
        this.fetchData({skip: this.skip, take: this.take, filter: this.filter});
    },
    data() {
        return {
            sort: null,
            filter: {
                logic: "and",
                filters: [],
            },
            isLoading: false,
            fullPage: true,
            result: [],
            skip: 0,
            take: 10,
            total: 0,
            impersonateLoadingId: null,
            richMenuPendingBrandId: null,
            richMenuUploadingId: null,
            showLineDialog: false,
            lineDialogLoading: false,
            lineSaving: false,
            lineExisting: null,
            lineForm: {
                brandId: null,
                brandName: "",
                providerId: "",
                providerName: "",
                channelId: "",
                liffId: "",
                accessToken: "",
                channelSecret: "",
            },
            columns: [
                {field: "id", title: "", hidden: true},
                {field: "name", title: "品牌名稱"},
                {field: "companyName", title: "公司名稱"},
                {field: "businessId", title: "統一編號"},
                {field: "code", title: "品牌代碼"},
                {field: "storeCount", title: "門市數"},
                {field: "operatorCount", title: "操作人數"},
                {field: "primaryOperatorSubject", title: "主要操作人"},
                {field: "operatorSubjectsText", title: "全部操作人"},
                {field: "createTime", title: "建立日期", type: "date", format: "{0: yyyy-MM-dd HH:mm:ss}"},
                {title: "操作", cell: "impersonateCell", filterable: false, sortable: false, width: "380px"},
            ],
            searchCondition: {
                name: "",
                companyName: "",
                businessId: "",
                primaryOperatorSubject: "",
            },
        };
    },
    components: {
        Layout,
        Grid,
        Loading,
    },
    watch: {
        "searchCondition.name": function (newValue) {
            this.setFilter("name", newValue, "contains");
        },
        "searchCondition.companyName": function (newValue) {
            this.setFilter("companyName", newValue, "contains");
        },
        "searchCondition.businessId": function (newValue) {
            this.setFilter("businessId", newValue, "contains");
        },
        "searchCondition.primaryOperatorSubject": function (newValue) {
            this.setFilter("primaryOperatorSubject", newValue, "contains");
        },
    },
    methods: {
        sortChangeHandler: function (e) {
            setTimeout(() => {
                this.sort = e.sort;
                this.fetchData({skip: this.skip, take: this.take, filter: this.filter, sort: this.sort});
            }, 200);
        },
        pageChangeHandler: function (event) {
            setTimeout(() => {
                this.skip = event.page.skip;
                this.take = event.page.take;
                this.fetchData({skip: this.skip, take: this.take, filter: this.filter, sort: this.sort});
            }, 300);
        },
        fetchData: function (dataState) {
            let self = this;
            self.isLoading = true;
            const queryStr = `${toDataSourceRequestString(dataState)}`;
            const baseUrl = "/api/QueryBrand";
            const init = {method: "GET", accept: "application/json", headers: {}};
            fetch(`${baseUrl}?${queryStr}`, init)
                .then((response) => response.json())
                .then(({data, total}) => {
                    this.result = data.map((item) => {
                        return {
                            ...item,
                            operatorSubjectsText: Array.isArray(item.operatorSubjects)
                                ? item.operatorSubjects.join(", ")
                                : "",
                        };
                    });
                    this.total = total;
                    self.isLoading = false;
                })
                .catch(() => {
                    self.isLoading = false;
                });
        },
        setFilter: function (fieldName, newValue, operator) {
            if (newValue !== "") {
                let index = this.filter.filters.findIndex(
                    (x) => x.field === fieldName
                );
                if (index === -1) {
                    this.filter.filters.push({
                        field: fieldName,
                        operator: operator,
                        value: newValue,
                    });
                } else {
                    this.filter.filters[index].value = newValue;
                }
            } else {
                let index = this.filter.filters.findIndex(
                    (x) => x.field === fieldName
                );
                if (index !== -1) {
                    this.filter.filters.splice(index, 1);
                }
            }
        },
        doSearch: function () {
            this.resetPager();
            this.fetchData({skip: this.skip, take: this.take, filter: this.filter, sort: this.sort});
        },
        resetPager: function () {
            this.skip = 0;
            this.take = 10;
        },
        openImpersonate: function (brandId) {
            this.impersonateLoadingId = brandId;
            fetch("/api/ImpersonateBrand", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({brandId}),
            })
                .then((res) => {
                    if (!res.ok) throw new Error(`代看失敗（${res.status}）`);
                    return res.json();
                })
                .then(({redirectUrl}) => {
                    window.open(redirectUrl, "_blank");
                })
                .catch((err) => {
                    alert(err.message || "代看功能發生錯誤，請稍後再試");
                })
                .finally(() => {
                    this.impersonateLoadingId = null;
                });
        },
        openLineDialog: function (item) {
            this.lineForm = {
                brandId: item.id,
                brandName: item.name,
                providerId: "",
                providerName: "",
                channelId: "",
                liffId: "",
                accessToken: "",
                channelSecret: "",
            };
            this.lineExisting = null;
            this.lineDialogLoading = true;
            this.showLineDialog = true;

            // 預填：先讀目前綁定的 LineChannel（不含機密欄位）
            fetch(`/api/BrandLineChannel?brandId=${encodeURIComponent(item.id)}`, {
                method: "GET",
                headers: {"Content-Type": "application/json"},
            })
                .then((res) => (res.ok ? res.json() : null))
                .then((payload) => {
                    const existing = payload && (payload.value || payload.data);
                    if (!existing) return;
                    this.lineExisting = existing;
                    this.lineForm.providerId = existing.providerId || "";
                    this.lineForm.providerName = existing.providerName || "";
                    this.lineForm.channelId = existing.channelId || "";
                    this.lineForm.liffId = existing.liffId || "";
                    // accessToken / channelSecret 不預填；留空代表「沿用既有」
                })
                .catch(() => {
                    // 讀取失敗或查無資料，維持空白
                })
                .finally(() => {
                    this.lineDialogLoading = false;
                });
        },
        closeLineDialog: function () {
            if (this.lineSaving) return;
            this.showLineDialog = false;
        },
        saveLineChannel: function () {
            if (!this.lineForm.providerId || !this.lineForm.channelId) {
                alert("Provider ID 與 Channel ID 必填");
                return;
            }
            this.lineSaving = true;
            fetch("/api/BrandLineChannel", {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify({
                    brandId: this.lineForm.brandId,
                    providerId: this.lineForm.providerId,
                    providerName: this.lineForm.providerName,
                    channelId: this.lineForm.channelId,
                    liffId: this.lineForm.liffId,
                    accessToken: this.lineForm.accessToken,
                    channelSecret: this.lineForm.channelSecret,
                }),
            })
                .then((res) => {
                    if (!res.ok) {
                        return res.text().then((t) => {
                            throw new Error(`設定失敗（${res.status}）${t}`);
                        });
                    }
                    return res.json();
                })
                .then(() => {
                    alert("LINE Channel 設定成功，已同步 Destination / 加好友連結");
                    this.showLineDialog = false;
                })
                .catch((err) => {
                    alert(err.message || "LINE Channel 設定發生錯誤，請稍後再試");
                })
                .finally(() => {
                    this.lineSaving = false;
                });
        },
        openRichMenuPicker: function (brandId) {
            this.richMenuPendingBrandId = brandId;
            // 清空 value 才能讓使用者重選同一個檔案也能觸發 change
            if (this.$refs.richMenuFileInput) {
                this.$refs.richMenuFileInput.value = "";
                this.$refs.richMenuFileInput.click();
            }
        },
        downloadLogo: function (brandId) {
            // 後端會回 Content-Disposition: attachment，瀏覽器直接觸發下載，不會離開當前頁
            window.location.href = `/api/BrandLogo?brandId=${encodeURIComponent(brandId)}`;
        },
        onRichMenuFileSelected: function (event) {
            const file = event.target.files && event.target.files[0];
            const brandId = this.richMenuPendingBrandId;
            this.richMenuPendingBrandId = null;
            if (!file || !brandId) return;

            // LINE 圖文選單圖片硬上限 1MB（超過會被 LINE 端的 nginx 退 413）
            if (file.size > 1_000_000) {
                alert("圖片大小必須小於 1MB（LINE 圖文選單上限）");
                return;
            }

            const fd = new FormData();
            fd.append("image", file);

            this.richMenuUploadingId = brandId;
            fetch(`/api/BrandLineChannel/${encodeURIComponent(brandId)}/richmenu`, {
                method: "POST",
                body: fd,
            })
                .then((res) => {
                    if (!res.ok) {
                        return res.text().then((t) => {
                            throw new Error(`上傳失敗（${res.status}）${t}`);
                        });
                    }
                    return res.json();
                })
                .then(() => {
                    alert("圖文選單已上傳並設為預設");
                })
                .catch((err) => {
                    alert(err.message || "圖文選單上傳發生錯誤，請稍後再試");
                })
                .finally(() => {
                    this.richMenuUploadingId = null;
                });
        },
    },
};
</script>

<style scoped>
.line-dialog-backdrop {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.45);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050;
}

.line-dialog-card {
    width: 100%;
    max-width: 520px;
    max-height: 90vh;
    overflow-y: auto;
    margin: 0;
}
</style>
